import { observable, computed } from 'mobx'

class Store {
  @observable tab = 'video'

  changeTab = e => {
    this.tab = e.target.value
  }

  @computed
  get isVideoTab() {
    return this.tab === 'video'
  }
}

export default Store
